
export const SET_PRODUTOS = 'SET_PRODUTOS';
export const SET_LOADING = 'SET_LOADING';
export const SET_PAGE = 'SET_PAGE';